import React from 'react'
import PropTypes from 'prop-types'
import { FormattedDate } from 'react-intl'
import { format } from 'date-fns'

import './style.scss'

// Reference :
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat/DateTimeFormat
// https://formatjs.io/docs/react-intl/components#formatteddate
// https://date-fns.org/v2.19.0/docs/format

const CustomDate = ({ value, customFormat, extraClasses, id, ...restProps }) => {
  return (
    <React.Fragment>
      {!!value || value === 0 ? (
        <span {...(id ? { id } : {})} className={`fil-date-container ${extraClasses}`}>
          {customFormat ? format(new Date(value), customFormat) : <FormattedDate value={new Date(value).getTime()} {...restProps} />}
        </span>
      ) : (
        <span>-</span>
      )}
    </React.Fragment>
  )
}

CustomDate.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  id: PropTypes.string,
  extraClasses: PropTypes.string,
  customFormat: PropTypes.string
}

CustomDate.defaultProps = {
  id: '',
  extraClasses: '',
  customFormat: ''
}

export default CustomDate
